// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Ldj1","insightsList":"newBusinessInsightsMenu_insightsList__1NFic","active":"newBusinessInsightsMenu_active__2tuMY"};